import { Charsets_getInstancezrqwjk0yrlyw as Charsets_getInstance } from '../charsets/Charset.js.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  readString2nvggcfaijfhd as readString,
  readString3v6duspiz33tv as readString_0,
} from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Utf8.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { decode1t43jmuxrxpmo as decode } from '../charsets/Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readText(_this__u8e3s4, charset, max) {
  charset = charset === VOID ? Charsets_getInstance().e4p_1 : charset;
  max = max === VOID ? 2147483647 : max;
  if (charset.equals(Charsets_getInstance().e4p_1)) {
    if (max === 2147483647)
      return readString(_this__u8e3s4);
    _this__u8e3s4.y3y(fromInt(max));
    var tmp0 = _this__u8e3s4.r3y().q2();
    // Inline function 'kotlin.math.min' call
    var b = fromInt(max);
    var count = tmp0 <= b ? tmp0 : b;
    return readString_0(_this__u8e3s4, count);
  }
  return decode(charset.v4p(), _this__u8e3s4, max);
}
//region block: exports
export {
  readText as readText27783kyxjxi1g,
};
//endregion

//# sourceMappingURL=Strings.nonJvm.mjs.map
